import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Modal from '../../../../../Modal/Modal';
import LoadingIndicator from '../../../../../LoadingIndicator/LoadingIndicator';
import Utility from '../../../../../../../util/utilityfunctions';
import StyledGuidanceItem from '../../../../../CanvasForm/Bodies/Common/StyledGuidanceItem';

const DeleteAttributeModal = ({setShowModal, showModal, description, removeAttribute, loading, labels, showDeleteModal}) => {
	return (
		<Modal
			show={showModal}
			modalsize={'medium'}
			showButtons={true}
			title={labels.modalTitle}
			closeBtnTitle={labels.modalCancelButton}
			confirmBtnTitle={labels.modalConfirmButton}
			onHide={() => setShowModal(false)}
			onOkClick={() => removeAttribute()}
			isCancelButtonDisabled={loading}
			isOkButtonDisabled={loading}
			disableClose={loading}
			closeTitle={labels.modalCancelButton}
		>
			<StyledModalBody>
				{loading && (
					<section className={'loaderSection'}>
						<LoadingIndicator />
					</section>
				)}
				{!loading && (
					<>
						<section className={'modal-description '}>{labels.modalDescription}</section>
						<section className={'modal-content'}>
							{showDeleteModal ? (
								<>
									<section className={'content-header'}>{labels.additionalDocumentationLabel}</section>
									<section className={'content-description'}>
										<StyledGuidanceItem className="StyledGuidanceItem">
											{Utility.createRichTextElement(description)}
										</StyledGuidanceItem>
									</section>
								</>
							) : (
								<section className={'content-header'}>{description}</section>
							)}
						</section>
					</>
				)}
			</StyledModalBody>
		</Modal>
	);
};

DeleteAttributeModal.propTypes = {
	setShowModal: PropTypes.func.isRequired,
	showModal: PropTypes.bool.isRequired,
	description: PropTypes.string.isRequired,
	loading: PropTypes.bool.isRequired
};

const StyledModalBody = Styled.section`
    .modal-description {
        padding-bottom: var(--px-24);
		font-size: var(--px-16);
		font-weight: 300;
		line-height: var(--px-24);
		color: var(--neutrals-900);
		border-bottom: var(--px-1) solid var(--neutrals-100);
        color: var(--neutrals-900);
    }
    .modal-content{
        padding-top: var(--px-24);
        font-size: var(--px-14);
        line-height: var(--px-20);
        color: var(--neutrals-900);
        font-weight: 400;
        .content-header{
            color: var(--neutrals-700);
            padding-bottom: var(--px-12);
        }
		.content-description{
			border-left: var(--px-4) solid var(--teal-600);
			padding-left: var(--px-8);
			font-size: var(--px-14);
			line-height: var(--px-20);
			color: var(--neutrals-900);
			word-break: break-word;
			ol,ul{
				padding-left: var(--px-16);
				font-weight: 300;
			}
		}
    }
    .loaderSection {
		padding-top: calc(var(--px-70) - var(--spacing-large));
		width: calc(100% - calc(2 * var(--spacing-x-large)));
		display: flex;
		justify-content: center;
		}
`;

export default DeleteAttributeModal;
